import React, { useState, Fragment, useEffect } from "react";
import {
  Routes,
  Route,
  Link,
  NavLink,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { MdNotificationsNone, MdSearch, MdPersonOutline } from "react-icons/md";
import logo from "../../images/logo.png";
import logoBlack from "../../images/logo-black.png";
import hr1 from "../../images/hr1.png";
import Image from "react-bootstrap/Image";
import styles from "./SiteNav.module.scss";
import Login from "../ui/Auth/Login";
import { useSelector, useDispatch } from "react-redux";
import { getProfile, logout } from "../../store/authMethods";
import {
  toggleHamburger,
  changeTheme,
  getNotification,
  markAsRead,
} from "../../store/publicMethods";
import Offcanvas from "react-bootstrap/Offcanvas";
import { BsSunFill, BsMoonFill } from "react-icons/bs";
import toast, { Toaster } from "react-hot-toast";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import { Animated } from "react-animated-css";
import DatePosted from "../ui/common/DatePosted";
import BannerToolbar from "../ui/BannerToolbar/BannerToolbar";

function SiteNav() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const profileData = useSelector((state) => state.auth.myProfile);
  const isNavExpanded = useSelector((state) => state.public.isNavExpanded);
  const notification = useSelector((state) => state.public.notification);
  const [show, setShow] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = useState();
  const [offCanvasShow, setOffCanvasShow] = useState(false);
  const [activeTheme, setActiveTheme] = useState("");
  const [toggleSearch, setToggleSearch] = useState(false);
  const [searchParams] = useSearchParams();
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getProfile());
    }
  }, [isLoggedIn]);

  const handleOffCanvasClose = () => {
    setOffCanvasShow(false);
    dispatch(toggleHamburger(false));
  };
  const handleOffCanvasShow = () => setOffCanvasShow(true);

  useEffect(() => {
    setNavOpen(isNavExpanded);
    if (!isNavExpanded) {
      handleOffCanvasClose();
    }
  }, [isNavExpanded]);

  const hamburgerNavHandler = () => {
    dispatch(toggleHamburger(!navOpen));
    setNavOpen(!navOpen);
    handleOffCanvasShow();
  };

  useEffect(() => {
    const currentTheme = localStorage.getItem("theme");
    if (!currentTheme) {
      localStorage.setItem("theme", "light");
      setActiveTheme("light");

      changeThemeHandler();
    } else {
      setActiveTheme(currentTheme);
      dispatch(changeTheme(currentTheme));
      document.body.classList.add(currentTheme);
    }
  }, []);

  const changeThemeHandler = () => {
    const changeTo =
      localStorage.getItem("theme") === "dark" ? "light" : "dark";
    dispatch(changeTheme(changeTo));
    setActiveTheme(changeTo);
    document.body.classList.remove("dark", "light");
    document.body.classList.add(changeTo);
  };

  const handleNotificationClick = (notification) => {
    dispatch(markAsRead(notification.uuid));
  };

  const showNotifications = () => {
    setIsNotificationLoading(true);
    dispatch(getNotification("?offset=0&limit=10&status=False")).then(() =>
      setIsNotificationLoading(false)
    );
  };

  return (
    <>
      <Toaster
        toastOptions={{
          className: "",
          style: {
            zIndex: "999999",
          },
        }}
      />
      <Login setShow={setShow} show={show} />
      <Navbar className={`${styles.siteNav} py-3`} fixed="top" expand="lg">
        <Container className="px-lg-0">
          <Navbar.Brand>
            <NavLink to={isLoggedIn ? "/home" : "/"}>
              <Image
                className={styles.navLogo}
                src={activeTheme === "dark" ? logo : logoBlack}
              />
            </NavLink>
          </Navbar.Brand>

          <div
            className={`ms-auto d-flex align-items-center order-lg-2 ${styles.topNav}`}
          >
            <MdSearch
              className="me-2 cursor-pointer"
              size={"28px"}
              onClick={() => setShowSearch(true)}
            />
            {isLoggedIn && (
              <NavDropdown
                drop="down"
                title={
                  <MdNotificationsNone
                    onClick={showNotifications}
                    className=""
                    size={"28px"}
                  />
                }
                className="me-3 d-none d-lg-block dropNotification"
              >
                {isNotificationLoading ? (
                  <NavDropdown.Item as={"span"} className="dropItem p-0">
                    <div
                      className={`d-flex notificationItem g-0 small align-items-center px-3 text-muted`}
                    >
                      <div className="text-wrap text-muted">
                        <p className="m-0">
                          <em>Loading...</em>
                        </p>
                      </div>
                    </div>
                  </NavDropdown.Item>
                ) : notification && notification.length > 0 ? (
                  <>
                    <NavDropdown.Item as={"span"} className="dropItem p-0">
                      {notification.map((item, i) => (
                        <div
                          className={`d-flex notificationItem g-0 small align-items-center px-3 ${
                            item.read === true ? "text-muted" : ""
                          }`}
                          key={`notification_${i}`}
                          onClick={(e) => {
                            !item.read && handleNotificationClick(item);
                          }}
                        >
                          <div
                            className="col-2 ratio ratio-1x1 me-2"
                            style={{ maxWidth: "42px" }}
                          >
                            <Image src={hr1} style={{ objectFit: "cover" }} />
                          </div>
                          <div className="text-wrap">
                            <strong>{item?.title}</strong>
                            <p className="m-0 small">{item?.text}</p>
                          </div>
                          <small className="ms-auto text-muted align-self-start">
                            <DatePosted
                              date={item?.created_at}
                              daysOnly={true}
                            />
                          </small>
                        </div>
                      ))}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={"span"}
                      className="position-relative dropItem text-center py-2"
                    >
                      <Link to={"/notifications"} className="stretched-link">
                        View All Notifications
                      </Link>
                    </NavDropdown.Item>
                  </>
                ) : (
                  <NavDropdown.Item as={"span"} className="dropItem p-0">
                    <div
                      className={`d-flex notificationItem g-0 small align-items-center px-3 text-muted`}
                    >
                      <div className="text-wrap text-muted">
                        <p className="m-0">
                          <em>No notifications found.</em>
                        </p>
                      </div>
                    </div>
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}

            {activeTheme === "dark" ? (
              <BsSunFill
                className="me-2"
                title="Light Mode"
                style={{ cursor: "pointer" }}
                size={"25px"}
                onClick={changeThemeHandler}
              />
            ) : (
              <BsMoonFill
                className="me-2"
                title="Dark Mode"
                style={{ cursor: "pointer" }}
                size={"22px"}
                onClick={changeThemeHandler}
              />
            )}
            {isLoggedIn && (
              <p className="mb-0 px-2 d-none d-xl-inline-block">
                Welcome, {profileData?.user?.first_name}{" "}
                {profileData?.user?.last_name}!
              </p>
            )}
            {isLoggedIn ? (
              <NavDropdown
                drop="down"
                // title={<MdPersonOutline size={"28px"} />}
                title={
                  <div
                    className="ratio ratio-1x1 d-inline-block"
                    style={{ width: "18px" }}
                  >
                    <Image
                      src={
                        profileData?.profile_image_details?.url &&
                        profileData?.profile_image_details?.url
                      }
                      className={styles.dpPic}
                    />
                  </div>
                }
                className="me-3 d-none d-lg-block"
              >
                <NavDropdown.Item as={"span"} className="dropNav">
                  <Link to="/profile">
                    <div>Profile</div>
                  </Link>
                </NavDropdown.Item>

                <NavDropdown.Item
                  onClick={() => {
                    dispatch(logout());
                    navigate("/");
                  }}
                >
                  <div>Logout</div>
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Button
                variant="primary"
                onClick={() => setShow(true)}
                size="sm"
                className="d-none d-lg-block"
              >
                LOG IN
              </Button>
            )}
            <button
              className={`d-lg-none hamburger hamburger--collapse hamburger--spin ${
                navOpen && "is-active"
              }`}
              onClick={hamburgerNavHandler}
              type="button"
            >
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>

          {isLoggedIn && (
            <Navbar.Collapse className="order-lg-1" id="navbarScroll">
              <Nav
                className="ms-auto my-2 my-lg-0"
                style={{ maxHeight: "100vh" }}
                navbarScroll
                as={"ul"}
              >
                {!profileData?.user.is_superuser && (
                  <Nav.Link as={"li"}>
                    <NavLink to="/home">Home</NavLink>
                  </Nav.Link>
                )}
                {profileData?.client_user_details?.is_corporate_admin &&
                  !profileData?.user.is_superuser && (
                    <Nav.Link as={"li"}>
                      <NavLink to="/company-admin-panel">Admin Panel</NavLink>
                    </Nav.Link>
                  )}
                {profileData?.user.is_superuser && (
                  <Nav.Link as={"li"}>
                    <NavLink to="/super-admin-panel">Admin Panel</NavLink>
                  </Nav.Link>
                )}
                {!profileData?.client_user_details?.is_corporate_admin &&
                  !profileData?.user.is_superuser && (
                    <>
                      <Nav.Link as={"li"}>
                        <NavLink to="in-house">Fresh Cuts</NavLink>
                      </Nav.Link>
                      <Nav.Link as={"li"}>
                        <NavLink to="podcaster">Tune In</NavLink>
                      </Nav.Link>

                      {/* <NavDropdown as={"li"} title="T-Hub" className="dropNav">
                        <NavDropdown.Item as={NavLink} to="announcements">
                          Announcements
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="chat">
                          Chat
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="e-magazine">
                          E-Magazine
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="faq">
                          FAQs
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="feedback">
                          Feedback
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="games">
                          Games
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="hall-of-fame">
                          Hall of Fame
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="helpdesk">
                          Helpdesk
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="ideaboard">
                          Idea Board
                        </NavDropdown.Item>

                        <NavDropdown.Item as={NavLink} to="quiz">
                          Quiz
                        </NavDropdown.Item>

                        <NavDropdown.Item as={NavLink} to="sos">
                          SOS
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="survey">
                          Survey
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="todolist">
                          Todo List
                        </NavDropdown.Item>

                        <NavDropdown.Item as={NavLink} to="virtual-event">
                          Virtual Event
                        </NavDropdown.Item>
                      </NavDropdown> */}
                      <Nav.Link as={"li"}>
                        <NavLink to={"my-list"}>My List</NavLink>
                      </Nav.Link>
                    </>
                  )}
              </Nav>
            </Navbar.Collapse>
          )}
        </Container>
      </Navbar>

      <Offcanvas show={offCanvasShow} onHide={handleOffCanvasClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link to={isLoggedIn ? "/home" : "/"}>
              <Image
                src={activeTheme === "dark" ? logo : logoBlack}
                width={"150"}
              />
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul>
            <li className={`p-3 profileInfo`}>
              {isLoggedIn ? (
                <>
                  <p>Welcome, User!</p>
                  <div className="d-flex justify-content-between">
                    <Button
                      size="sm"
                      onClick={() => {
                        navigate("profile");
                      }}
                    >
                      PROFILE
                    </Button>{" "}
                    <Button
                      variant="link"
                      className="text-muted"
                      size="sm"
                      onClick={() => {
                        dispatch(logout());
                        navigate("/");
                      }}
                    >
                      LOG OUT
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <p>Please login to your account</p>{" "}
                  <Button size="sm" onClick={() => setShow(true)}>
                    LOG IN
                  </Button>
                </>
              )}
            </li>
            {isLoggedIn && (
              <>
                <li>
                  <Link to="/home">Home</Link>
                </li>
                <li>
                  <Link to="/in-house">Fresh Cuts</Link>
                </li>
                <li>
                  <Link to="/podcaster">Tune In</Link>
                </li>
                <li>
                  <Link to="/t-hub">T-Hub</Link>
                </li>
                <li>
                  <Link to="/my-list">My List</Link>
                </li>
              </>
            )}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      <SearchModal setShow={setShowSearch} show={showSearch} />
      {isLoggedIn && !profileData?.user.is_superuser && <BannerToolbar />}
    </>
  );
}

export default SiteNav;

function SearchModal({ setShow, show }) {
  const handleClose = () => setShow(false);
  const navigate = useNavigate();

  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body className="text-center">
          <Formik
            initialValues={{
              search: "",
            }}
            onSubmit={(values, { setSubmitting }) => {
              navigate(`/search?q=${values.search}`);
              handleClose();
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Control
                  type="text"
                  placeholder="Title, tags, categories"
                  name="search"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.search || ""}
                />
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}
